import { PureComponent } from 'react';
import { ApplicationState } from 'store';
import { bindActionCreators, Dispatch } from 'redux';
import { Row } from 'react-bootstrap';
import { thunks, ContactsActions } from 'store/contacts/actions';
import { LoadingSpinner, ExpansionPanel } from 'shared/components';
import { connect } from 'react-redux';
import CrayonContacts from 'modules/home/components/CrayonContacts/CrayonContacts';
import SettingsList from '../SettingsList/SettingsList';

const mapStateToProps = (state: ApplicationState) => ({
  contactsState: state.contacts,
  settingsState: state.settings,
  translationsState: state.i18n,
});

const mapDispatchToProps = (dispatch: Dispatch<ContactsActions>) =>
  bindActionCreators(
    {
      fetchContacts: thunks.requestContactsThunk,
    },
    dispatch
  );

type AdminPanelProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class AdminPanel extends PureComponent<AdminPanelProps> {
  // This method is called when the component is first added to the document
  public componentDidMount() {
    this.getCrayonContacts();
  }

  public componentDidUpdate() {
    this.getCrayonContacts();
  }

  private getCrayonContacts() {
    const { settingsState, contactsState } = this.props;
    if (
      !settingsState.loading &&
      settingsState.error === undefined &&
      settingsState.settings !== undefined
    ) {
      const { featureFlags } = settingsState.settings;
      if (featureFlags.showCrayonContacts) {
        if (
          !contactsState.loading &&
          contactsState.error === undefined &&
          contactsState.items === undefined
        ) {
          this.props.fetchContacts();
        }
      }
    }
  }

  render() {
    const {
      translationsState: {
        loading: loadingTranslations,
        error: translationsError,
        translations,
      },
      settingsState: {
        loading: loadingSettings,
        error: settingsError,
        settings,
      },
    } = this.props;

    const hasTranslations =
      !loadingTranslations &&
      translationsError === undefined &&
      translations !== undefined;
    const hasSettings =
      !loadingSettings && settingsError === undefined && settings !== undefined;
    const showLoading = !hasTranslations || !hasSettings;
    if (showLoading) {
      return (
        <LoadingSpinner className="section-margin blockquote text-center" />
      );
    }

    const { featureFlags } = settings!;

    if (!featureFlags.showCrayonContacts) {
      return null;
    }

    return (
      <ExpansionPanel
        title={translations!.AdminHeading}
        activeKey="0"
        columns={2}
      >
        <Row>
          <CrayonContacts />
          <SettingsList />
        </Row>
      </ExpansionPanel>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPanel);
